module.exports = __webpack_public_path__ + "videos/3d-export_cn_hevc.cf3fb23.mp4";